import React from 'react';
import { connect } from 'react-redux';
import Link from '@visa/vds/link';
import $ from 'jquery';
import { hideDivBasedOnId, showDivBasedOnId } from '../../../../../commons/ui-commons';
import {setBodyLevelSelectedTab} from '../js/live-console';
import { getIsWidget } from '../../../../../lhs/reducers/configuration-reducer';

/**
 * Request description in live console tab 
 */
 var hasBodyParams = false;
 var exampleSummary = "";


class SampleRequestDropDownInLiveConsole extends React.Component
{

   render()
   {
       return (
        <li
        id="sample-request-data"
        style={{
            display: "flex",
            marginTop: "15px",
            marginBottom: "10px",
            marginLeft: "15px",
        }}
        >
        <span style={{ fontWeight: "bold", fontSize: "14px" }}>
            Sample Request:
        </span>
        <span style={{ marginLeft: "10px" }}>
            {this.props.exampleSummary}
        </span>
        {!getIsWidget() && (
            <div class="changeLink" style={{ marginLeft: "10px" }}>
            <Link
                tabindex="0"
                class="changeConfig color_theme_link"
                onClick={() => {
                showDivBasedOnId("tab-Configuration");
                hideDivBasedOnId("tab-Request Builder");
                if (this.props.hasBodyParams) {
                    setBodyLevelSelectedTab(1);
                } else {
                    setBodyLevelSelectedTab(0);
                }

                var element = document.getElementById(
                    "sampleRequestDropDownDiv"
                );
                if (element != null) {
                    element.scrollIntoView();
                }
                $("#sampleRequestDropDownDiv .vds-input-bar input").trigger(
                    "click"
                );
                }}
            >
                Change
            </Link>
            </div>
        )}
        </li>
       );

    }
}
function mapStateToProps(state){
    hasBodyParams = (state.lhsReducer.hasBodyParams == undefined) ? false: state.lhsReducer.hasBodyParams;
    exampleSummary = (state.examplesReducer.exampleSummary == undefined)? "No Sample Request Available": state.examplesReducer.exampleSummary;


    return{      
        hasBodyParams : hasBodyParams,
        exampleSummary :exampleSummary
    };
   
}

export default connect(mapStateToProps)(SampleRequestDropDownInLiveConsole);